var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js");

var core = require('@citation-js/core');

require('@citation-js/plugin-bibjson');

require('@citation-js/plugin-bibtex');

require('@citation-js/plugin-csl');

require('@citation-js/plugin-doi');

require('@citation-js/plugin-ris');

require('@citation-js/plugin-wikidata');

var citeproc = require('citeproc');

var name = require('@citation-js/name');

var date = require('@citation-js/date');

function clone(obj) {
  var copy = {};

  for (var key in obj) {
    copy[key] = typeof obj[key] === 'object' ? clone(obj[key]) : obj[key];
  }

  return copy;
}

var attr = {
  getAttributedEntry: function getAttributedEntry(string, name, value) {
    return string.replace(/^\s*<[a-z]+/i, "$& data-".concat(name, "=\"").concat(value, "\""));
  },
  getPrefixedEntry: function getPrefixedEntry(value, id) {
    return attr.getAttributedEntry(value, 'csl-entry-id', id);
  },
  getWrappedEntry: function getWrappedEntry(value, source, affixes) {
    var getAffix = function getAffix(source, affix) {
      return typeof affix === 'function' ? affix(source) : affix == null ? affix : '';
    };

    if (affixes.prepend == null && affixes.append == null) {
      return value;
    }

    var prefix = getAffix(source, affixes.prepend);
    var suffix = getAffix(source, affixes.append);
    var start = '';
    var end = '';
    var match = value.match(/^([^>]+>)([\s\S]+)(<[^<]+)$/i);

    if (match) {
      start = match[1];
      value = match[2];
      end = match[3];
    }

    return start + prefix + value + suffix + end;
  }
};

function Cite(data, opts) {
  if (!(this instanceof Cite)) {
    return new Cite(data, opts);
  }

  var self = new core.Cite(data, opts);
  this._options = self._options;
  this.log = self.log;
  this.data = self.data;
}

Cite.prototype = Object.create(core.Cite.prototype);
Cite.async = core.Cite.async;
Cite.validateOptions = core.Cite.validateOptions;
Cite.validateOutputOptions = core.Cite.validateOutputOptions;
Cite.input = core.plugins.input.chain;
Cite.inputAsync = core.plugins.input.chainAsync;
Cite.util = Object.assign({
  attr: attr
}, core.util);
Cite.version = {
  cite: core.version,
  citeproc: citeproc.PROCESSOR_VERSION
};
var CSL = core.plugins.config.get('@csl');
Cite.CSL = {
  engine: require('@citation-js/plugin-csl/lib/engines').fetchEngine,
  item: function item(data) {
    return function (id) {
      return data.find(function (entry) {
        return entry.id === id;
      });
    };
  },
  locale: function locale(lang) {
    return CSL.styles.get(CSL.styles.has(lang) ? lang : 'en-US');
  },
  style: function style(_style) {
    return CSL.templates.get(CSL.templates.has(_style) ? _style : 'apa');
  },
  register: {
    addTemplate: CSL.templates.add.bind(CSL.templates),
    getTemplate: CSL.templates.get.bind(CSL.templates),
    hasTemplate: CSL.templates.has.bind(CSL.templates),
    addLocale: CSL.locales.add.bind(CSL.locales),
    getLocale: CSL.locales.get.bind(CSL.locales),
    hasLocale: CSL.locales.has.bind(CSL.locales)
  }
};
Cite.plugins = clone(core.plugins);
delete Cite.plugins.input.util.clean;
Cite.parse = Object.assign({
  input: {
    chain: core.plugins.input.chain,
    chainAsync: core.plugins.input.chainAsync,
    chainLink: core.plugins.input.chainLink,
    chainLinkAsync: core.plugins.input.chainLinkAsync,
    data: core.plugins.input.data,
    dataAsync: core.plugins.input.dataAsync,
    type: core.plugins.input.type,
    async: {
      chain: core.plugins.input.chainAsync,
      chainLink: core.plugins.input.chainLinkAsync,
      data: core.plugins.input.dataAsync
    }
  },
  name: name.parse,
  date: date.parse,
  csl: core.plugins.input.util.clean,
  bibjson: require('@citation-js/plugin-bibjson').parsers.json.record,
  bibtex: function (parsers, entries, types) {
    return {
      json: function json(entries) {
        return entries.parse([].concat(entries));
      },
      prop: function prop(field, value) {
        var parsed = entries.parse([{
          type: 'book',
          properties: _defineProperty({}, field, value)
        }])[0];
        var key = Object.keys(parsed).find(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
              key = _ref2[0];

          return key !== 'type';
        });
        return [key, parsed[key]];
      },
      text: function text(file) {
        return parsers['@biblatex/text'].parse(file);
      },
      type: function type(_type) {
        return types[_type] || 'book';
      }
    };
  }(require('@citation-js/plugin-bibtex/lib/input').formats, require('@citation-js/plugin-bibtex/lib/input/entries'), require('@citation-js/plugin-bibtex/lib/mapping/bibtexTypes').target),
  bibtxt: function (bibtxt) {
    return {
      text: bibtxt.parse,
      textEntry: bibtxt.textEntry
    };
  }(require('@citation-js/plugin-bibtex/lib/input/bibtxt')),
  doi: function (doi) {
    return {
      api: doi.parsers.api.parse,
      id: doi.parsers.id.parse,
      async: {
        api: doi.parsers.api.parseAsync
      }
    };
  }(require('@citation-js/plugin-doi')),
  json: require('@citation-js/core/lib/plugin-common/input').parsers.json.parse,
  wikidata: function (wikidata) {
    return {
      json: wikidata.parsers.entity.parse,
      list: wikidata.parsers.id.parse,
      prop: wikidata.parsers.prop.parse,
      type: wikidata.parsers.prop.parseType,
      async: {
        json: wikidata.parsers.entity.parseAsync,
        prop: function prop() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return Promise.resolve(wikidata.parsers.prop.parse.apply(this, args));
        }
      }
    };
  }(require('@citation-js/plugin-wikidata'))
}, Cite.plugins.input);
Cite.get = Object.assign({
  dict: Cite.plugins.dict,
  name: name.format,
  date: date.format,
  bibtex: function (formatters, entries, converters, types) {
    return {
      json: function json(entry) {
        return entries.formatBibtex([entry])[0];
      },
      label: function label(_ref3) {
        var id = _ref3.id,
            label = _ref3['citation-label'],
            author = _ref3.author,
            issued = _ref3.issued,
            suffix = _ref3['year-suffix'],
            title = _ref3.title;
        return converters.LABEL.toSource(id, label, author, issued, suffix, title);
      },
      text: function text(entries, asHtml) {
        return formatters.bibtex(entries, {
          format: asHtml ? 'html' : 'text'
        });
      },
      type: function type(_type2) {
        return types[_type2] || 'misc';
      }
    };
  }(require('@citation-js/plugin-bibtex/lib/output').default, require('@citation-js/plugin-bibtex/lib/output/entries'), require('@citation-js/plugin-bibtex/lib/mapping/shared').Converters, require('@citation-js/plugin-bibtex/lib/mapping/bibtexTypes').target),
  bibtxt: require('@citation-js/plugin-bibtex/lib/output/bibtxt').format,
  json: require('@citation-js/core/lib/plugin-common/output').default.data,
  label: require('@citation-js/core/lib/plugin-common/output').default.label
}, Cite.plugins.output);
module.exports = Cite;